import { createContext, useContext } from 'react';

const ViewAsContext = createContext(null);

export const useViewAsUser = () => useContext(ViewAsContext);

export default ViewAsContext;